/* eslint-disable unicode-bom */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Table, notification, Select } from "antd";
import { connect } from "react-redux";
import ModuleProductDetailDescription from "components/elements/detail/modules/elements/ModuleProductDetailDescription";
import { languageLable, findParameterFromUrl } from "utilities/helpers";
import { PRODUCT_ACTION } from "utilities/constants";
import API from "api/api";
import swal from "sweetalert";
import Button from '@mui/material/Button';

/**
 * Grouped Product
 */
const { Option } = Select;
var api;
class SchemeProductDetails extends Component {
  constructor(props) {
    super(props);
    api = new API();
    this.state = {
      quantity: 0,
      selectedVariant: null,
      price: null,
      productAttributeValue: null, // SET THE PRODUCT DATA INTO STATE FOR MANAGING THE ATTRIBUTE
      loyaltypoint: 0,
      productAction: "Add +",
      serialNumberS: "",
      totalSchemes: 0,
      focQuantity: 0,
      originalQuantity: 0,
      balanceMainQty: 0,
      balanceFOCQty: 0,
        mainProducts: [],
        productsSelected: {
            productData: props.productData || []
        }
      // Add to cart by default in case of action present in URL then it should be exchange flow
    };
  }

  componentDidMount = () => {
    this.setState({
      productAttributeValue: this.props.productData[0],
    });
     
    this.handleLoyaltyProductPoint();

    const action = findParameterFromUrl(window.location, "action");
  
    this.setState({
      totalSchemes: findParameterFromUrl(window.location, "totalscheme"),
      originalQuantity: findParameterFromUrl(window.location, "original"),
      focQuantity: findParameterFromUrl(window.location, "foc"),
      balanceMainQty: findParameterFromUrl(window.location, "totalscheme") * findParameterFromUrl(window.location, this.props.isMainProductScheme && this.props.isMainProductScheme === true ? "original" : "foc"),
      balanceFOCQty: findParameterFromUrl(window.location, "totalscheme") *  findParameterFromUrl(window.location, "foc")
    });
    const mainProducts = JSON.parse(localStorage.getItem('mainProducts')) || [];
    const focProducts = JSON.parse(localStorage.getItem('focProducts')) || [];
    const balMQty = localStorage.getItem('balanceMainQty');
    const balFQty = localStorage.getItem('balanceFOCQty');

    if (this.props.isMainProductScheme && this.props.isMainProductScheme === true) {
      if (mainProducts) {
        this.setState({
          mainProducts: mainProducts
        });
      }
      if (balMQty) {
        this.setState({
          balanceMainQty: balMQty
        });
      }
    } else {
      if (focProducts) {
        this.setState({
          mainProducts: focProducts
        });
      }
      if (balFQty) {
        this.setState({
          balanceMainQty: balFQty
        });
      }
    }
    if (action === PRODUCT_ACTION.EXCHANGE) {
      this.setState({
        productAction: PRODUCT_ACTION.EXCHANGE,
      });
    }
  };

  handleAddItemToCart = async (row) => {
    const { selectedLanguageData } = this.props.app;
    if (this.state.balanceMainQty == 0) {
      notification.warning({
                  message: "",
                  description: languageLable(
                    selectedLanguageData,
                    "Scheme quantity limit exceeded. To add more, please adjust the number of selected schemes."
                  ),
                });
      return;
    }
    const productData = this.props.productData.find(obj => obj.Id = row.ProductId);
    const isAuthorized = Boolean(productData?.ProductListings[0]?.IsAuthorised);
    let consignmentType = null;
    if (isAuthorized) {
      const libraryRefilling = localStorage.getItem("LibraryRefilling");
      const url = window.location.pathname.split("/");
      const groupId = url[2];

      if (libraryRefilling) {
        this.props.history.push(`/account/library-order/${groupId}`);
      } else {
        const alertActions = await swal({
          title: "Do you want to Order Library Refill?",
          icon: "info",
          dangerMode: true,
          showCancelButton: true,
          closeOnConfirm: true,
          showLoaderOnConfirm: true,
          buttons: {
            cancel: "No",
            yes: {
              text: "Yes",
            },
          },
        });

        consignmentType = "none";
        if (alertActions === "yes") {
          consignmentType = "FillUp";
        }
      }
    }

    consignmentType = PRODUCT_ACTION.COMBOSCHEME;

    const businessId =
      this.props.auth &&
      this.props.auth.defaultAddress &&
      this.props.auth.defaultAddress.BusinessCustomerAddressMapping &&
      this.props.auth.defaultAddress.BusinessCustomerAddressMapping.BusinessId;

    const locationId =
      this.props.auth &&
      this.props.auth.defaultAddress &&
      this.props.auth.defaultAddress.BusinessCustomerAddressMapping &&
      this.props.auth.defaultAddress.BusinessCustomerAddressMapping.LocationId;

    // Add item to cart
    let addToCart = {
      productId: row.ProductId,
      businessId: businessId,
      businessLocationId: locationId,
      listingId: row.ProductListingId,
      amount: row.Price,
      offerAmount: row.Price,
      offerId: "",
      serialNumber: findParameterFromUrl(window.location, "serialno"),
      InvoiceNumber: findParameterFromUrl(window.location, "InvoiceNumber"),
      quantity: 1,
      comboSchemeId: this.props.comboSchemeId,
      consignmentType: consignmentType,
      isFOCCombo: !(this.props.isMainProductScheme && this.props.isMainProductScheme === true),
      id: row.Id,
    };
    this.updateCart(addToCart);
    productData.Quantity = 1;
    this.setState(
      prevState => ({
        balanceMainQty: prevState.balanceMainQty - 1
      }),
      () => {
        this.storeQuantityInLocalStorage( this.state.balanceMainQty);
      }
    );
  };

  updateCart = (addToCart) => {
    this.setState(prevState => {
      const updated = [...prevState.mainProducts, addToCart];
      this.storeArrayInLocalStorage(updated);
      return { mainProducts: updated };
    });
  };

    storeArrayInLocalStorage = (updated) => {
    if (this.props.isMainProductScheme && this.props.isMainProductScheme === true) {
      localStorage.setItem('mainProducts', JSON.stringify(updated));
      localStorage.setItem('balanceMainQty', this.state.balanceMainQty);
    } else {
      localStorage.setItem('focProducts', JSON.stringify(updated));
      localStorage.setItem('balanceFOCQty', this.state.balanceMainQty);
    }
  };

  storeQuantityInLocalStorage = (quantity) => {
    if (this.props.isMainProductScheme && this.props.isMainProductScheme === true) {
      localStorage.setItem('balanceMainQty', quantity);
    } else {
      localStorage.setItem('balanceFOCQty', quantity);
    }
  };

  handleIncreaseItemQty = (itemId) => {
    if (this.state.balanceMainQty == 0) {
      const { selectedLanguageData } = this.props.app;
      notification.warning({
                  message: "",
                  description: languageLable(
                    selectedLanguageData,
                    "Scheme quantity limit exceeded. To add more, please adjust the number of selected schemes."
                  ),
                });
      return;
    }
    const updatedProducts = this.state.mainProducts.map(product => {
      if (product.productId === itemId) {
        return { ...product, quantity: product.quantity + 1 };
      }
      return product;
    });
  
    this.setState({ mainProducts: updatedProducts });
    this.setState(
      prevState => ({
        balanceMainQty: prevState.balanceMainQty - 1
      }),
      () => {
        this.storeQuantityInLocalStorage( this.state.balanceMainQty);
      }
    );
    this.storeArrayInLocalStorage(updatedProducts);
  };

  handleDecreaseItemQty = (itemId, quantity) => {
    const updatedProducts = this.state.mainProducts.map(product => {
      if (product.productId === itemId) {
        return { ...product, quantity: product.quantity - 1 };
      }
      return product;
    });
  
    this.setState({ mainProducts: updatedProducts });
    if (quantity <= 1){
      this.removeItem(itemId);
    }
    this.setState(
      prevState => ({
        balanceMainQty: prevState.balanceMainQty + 1
      }),
      () => {
        this.storeQuantityInLocalStorage( this.state.balanceMainQty);
      }
    );
    this.storeArrayInLocalStorage(updatedProducts);
  };

  removeItem = (idToRemove) => {
    const updatedItems = this.state.mainProducts.filter(item => item.productId !== idToRemove);
    this.setState({ mainProducts: updatedItems });
  };

  onAttributeSelectionChange = (id, name, text) => {
    this.props.onAttributeSelectionChange(id, name, text);
  };

  prepareAttributeOption = () => {
      const productAttributeValue = this.props.productData;
    return (
      <div className="attribute-container">
        {productAttributeValue.Attributes &&
          productAttributeValue.Attributes.map((item, index) => {
            const options =
              productAttributeValue.AttributeValues &&
              productAttributeValue.AttributeValues.filter(
                (value) => value.attributeid === item.Id
              );
            return (
              <div className="attribute">
                <div className="title-container">
                  <strong>{item.Name}</strong>
                </div>
                <Select
                  showSearch
                  style={{ width: 200 }}
                  placeholder={`Select ${item.Name}`}
                  optionFilterProp="children"
                        onChange={(id) => {
                            const selectedOption = options.find((opt) => opt.id === id);
                            const selectedText = selectedOption ? selectedOption.text : null;
                            this.onAttributeSelectionChange(id, item.Name, selectedText)
                        }
                  }
                >
                  <Option value={null}>{`Please select`}</Option>
                  {options &&
                    options.map((option) => (
                      <Option value={option.id}>{option.text}</Option>
                    ))}
                </Select>
              </div>
            );
          })}
      </div>
    );
    };

  handleProceedButton = () => {
    const { selectedLanguageData } = this.props.app;
    const balMQty = localStorage.getItem('balanceMainQty');
    const balFQty = localStorage.getItem('balanceFOCQty');
    
    if (balMQty > 0 || balFQty > 0 || balMQty === null || balFQty === null) {
      if (this.props.isMainProductScheme && this.props.isMainProductScheme === true) {
        if (balMQty > 0 || balMQty === null) {
          notification.warning({
                      message: "",
                      description: `${balMQty}`+ languageLable(
                        selectedLanguageData,
                        " more Products remain to select"
                      ),
                    }); 
        } else {
          notification.warning({
            message: "",
            description: languageLable(
              selectedLanguageData,
              "Select Scheme Products"
            ),
          }); 
        }
      } else {
       if (balFQty > 0 || balFQty === null) {
          notification.warning({
                      message: "",
                      description: `${balFQty}` + languageLable(
                        selectedLanguageData,
                        " more Products remain to select"
                      ),
                    }); 
        } else {
          notification.warning({
            message: "",
            description: languageLable(
              selectedLanguageData,
              "Select Main Products"
            ),
          }); 
        }
      }
    } else {
      const mainProducts = JSON.parse(localStorage.getItem('mainProducts')) || [];
      const focProducts = JSON.parse(localStorage.getItem('focProducts')) || [];
      const mergedProducts = [...mainProducts, ...focProducts];
      let apiUrl = `AddItemsToCart?ConsignmentType=${PRODUCT_ACTION.COMBOSCHEME}`;

      api
        .post(apiUrl, {
          data: mergedProducts,
        })
        .then((response) => {
          if (response.StatusCode === 200 && response.Result) {
            notification.success({
              message: "Success",
              description: languageLable(
                selectedLanguageData,
                "Items has been successfully added to cart."
              ),
            });
              this.props.dispatch({
                  type: "FETCH_CART_DATA",
                  cartData: response.Result,
              });
            this.props.history.push("/account/cart")
          }
        });
    }
  };

  handleLoyaltyProductPoint = async () => {
    if (localStorage.getItem("IsLoyaltyEnable") === "true") {
      setTimeout(() => {
        //let gsku = JSON.parse(localStorage.getItem('@skugroup'));
        let gsku = localStorage.getItem("@skugroup");

        var requestOptions = {
          method: "GET",
          redirect: "follow",
        };

        //gsku.map(item =>{
        fetch(
          `https://ecomloyaltyuat.biotechhealthcare.com/api/GetLoyaltyPoint?productSku=${gsku}`,
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            this.setState({
              loyaltypoint: result.data.points,
            });
          })
          .catch((error) => console.error("error", error));
        //})
      }, 1000);
    }
  };
  

    handleProductChange = (event) => {
        const selectedName = event.target.value;
        this.setState({ productsSelected: { productData: this.props.allMainProducts[selectedName] } });
    };

  render() {
    //const { productData } = this.props;
    const { selectedLanguageData } = this.props.app;
    const currencySetting = localStorage.getItem("currency");
      const currencyDescription = localStorage.getItem("currencydescription");
      const { productData } = this.state.productsSelected;
    // const taxNameString = localStorage.getItem("taxNameString");
    const canOrder =
      this.props.auth &&
      this.props.auth.userData &&
      this.props.auth.userData.can_order === "true"
        ? true
        : false;

    const columns = [];
    if (productData && productData[0] && productData[0].Attributes) {
      productData[0].Attributes.forEach((item) => {
        columns.push({
          title: item.attribute,
          dataIndex: item.attribute,
          key: item.attributeid,
        });
      });
    }

    if (canOrder) {
      // Stock
      // columns.push({
      //   title: languageLable(selectedLanguageData, "Available Stock"),
      //   dataIndex: "Availability",
      //   key: "Available Stock",
      // });

      // Price
      columns.push({
        title: languageLable(selectedLanguageData, "Price"),
        dataIndex: "",
        key: "Price",
        render: (row) => {
          return (
            <div className="price">
              {languageLable(selectedLanguageData, "")}
              {currencySetting ? currencySetting : "₹ "}
              {row.Price}
              {row.DiscountPercent > 0 && <s>{row.MaxRetailPrice}</s>}
            </div>
          );
        },
      });

      // Action
      columns.push({
        title: languageLable(selectedLanguageData, "Action"),
        dataIndex: "",
        key: "Cart",
        render: (row) => this.getCartButton(canOrder, row),
      });
    }

    const attributeData = [];
    if (productData) {
      productData.forEach((detailsAttribute) => {
        // if ProductListing is available than show the record
        if (
          detailsAttribute !== null &&
          detailsAttribute.ProductListings !== null &&
          detailsAttribute.ProductListings.length > 0
        ) {
          let attributes = {};
          detailsAttribute.Attributes.forEach((item) => {
            attributes[item.attribute] = item.text;
          });

          detailsAttribute.ProductListings.forEach((ProductListing) => {
            attributes["PackingSize"] =
              ProductListing && ProductListing.PackingSize;
            if (ProductListing && canOrder) {
              attributes["ProductId"] = ProductListing.ProductId;
              attributes["key"] = ProductListing.ProductId;
                if (this.props.auth && this.props.auth.isLoggedIn && this.props.auth.isVerified) {
                // Product Not availble set notify button
                if (ProductListing.Availability !== "Enquiry") {
                  attributes["Availability"] =
                    ProductListing.Availability === "Unlimited"
                      ? ProductListing.Availability
                      : ProductListing.Quantity > 0
                      ? ProductListing.Quantity
                      : 0;

                  const taxValue =
                    ProductListing.TaxValue && ProductListing.TaxValue;
                  const offerPrice =
                    ProductListing.OfferPrice && ProductListing.OfferPrice;
                  const maxRetailPrice =
                    ProductListing.MaxRetailPrice &&
                    ProductListing.MaxRetailPrice;

                  attributes["Price"] = (offerPrice + taxValue).toFixed(2);

                  attributes["MaxRetailPrice"] = (
                    maxRetailPrice + taxValue
                  ).toFixed(2);

                  attributes["DiscountPercent"] =
                    ProductListing.DiscountPercent &&
                    ProductListing.DiscountPercent.toFixed(2);
                  attributes["ProductListingId"] = ProductListing.Id;
                } else {
                  attributes["Availability"] = "Enquiry";
                  attributes["Price"] = "---";
                  attributes["ProductListingId"] = ProductListing.Id;
                }
              }
            } else {
              attributes["ProductId"] = "---";
              attributes["key"] = Math.random();
              attributes["Availability"] = "---";
              attributes["Price"] = "---";
            }
          });

          attributeData.push(attributes);
        }
      });
    }
    const productAttributeValue = this.props.productData[0];
      var dropDownList = [];
      if (this.props.isMainProductScheme && this.props.isMainProductScheme === true) {
          if (this.props.allMainProducts && Object.keys(this.props.allMainProducts).length > 1) {
              dropDownList = Object.keys(this.props.allMainProducts);
          }
      } else {
          if (this.props.allFOCProducts && Object.keys(this.props.allFOCProducts).length > 1) {
              dropDownList = Object.keys(this.props.allFOCProducts);
          }
      }
    const ProductDetailViews = productData;
    const isLoyaltyEnable = localStorage.getItem("IsLoyaltyEnable");
     
    var ProductDetailViewsFilterData = [];
    var CustomFieldData = [];
    var customFieldDataUSD = "";
    var customFieldDataUSDValue = "";
    if (ProductDetailViews !== undefined) {
      ProductDetailViewsFilterData = ProductDetailViews.filter((i) => {
        return i !== null && i.ProductListings !== null
          ? i.ProductListings.length > 0
          : 0;
      });

      if (ProductDetailViewsFilterData.length > 0) {
        if (
          ProductDetailViewsFilterData[0].ProductListings[0].CustomFieldData !==
          undefined
        ) {
          CustomFieldData =
            ProductDetailViewsFilterData[0].ProductListings[0].CustomFieldData;
          var datacustom = JSON.parse(CustomFieldData);

          var data = [];
          var data1 = [];

          function isNumber(n) {
            return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
          }

          data = datacustom.filter((item) => {
            return isNumber(item.Value) === false ? item : "";
          });
          data1 = datacustom.filter((item) => {
            return isNumber(item.Value) === true ? item : "";
          });

          customFieldDataUSD = data.count > 0 ? data[0].Value : "";
          customFieldDataUSDValue =
            data.count > 0 ? parseFloat(data1[0].Value).toFixed(2) : "";
        }
      }
      }
      //console.log("Main: ", this.props.allMainProducts.length);
      //console.log("FOC: ", this.props.allFOCProducts);
    return (
      <div className="ps-product__info">
            {/* <div class="row" > */}
            <h1>{dropDownList && dropDownList.length > 1 ? (
                <select
                    value={productData[0]?.ProductName || ""}
                    onChange={this.handleProductChange}
                >
                    {dropDownList.map((product, index) => (
                        <option key={index} value={product}>
                            {product}
                        </option>
                    ))}
                </select>
            ) : (
                    <select disabled>
                    <option value={productData[0]?.ProductName}>
                        {productData[0]?.ProductName}
                    </option>
                </select>
            )}</h1>
            
            <div className="col-lg-7">
                <ModuleProductDetailDescription
                    product={productData[0]}
                    selectedLanguageData={selectedLanguageData}
                />
            </div>
        
        {currencyDescription !== "" ? (
          <>
            <div
              className="col-lg-7 new-line"
              style={{ marginTop: -15, marginBottom: 20 }}
            >
              {currencyDescription}
            </div>
          </>
        ) : (
          <></>
        )}
        <div
              className="col-lg-12 new-line"
              style={{ marginTop: -15, marginBottom: 20, justifyContent: 'end', display: 'flex' }}
            >
              {languageLable(selectedLanguageData, "Bal:")} <span className="ms-2" style={{ color: '#39C4DB', fontWeight: 'bold' }}>
              {this.state.balanceMainQty}
            </span> <span className="ms-2"> {languageLable(selectedLanguageData, "Units")} </span>
            
          </div>
          <div
              className="col-lg-12 new-line"
              style={{ marginTop: -15, marginBottom: 10, justifyContent: 'end', display: 'flex' }}
            >      <Button variant="contained" onClick={() => this.handleProceedButton()} 
                            style={{ borderRadius: 20, width: 160, height: 40, textAlign: 'center', background: '#39C4DB', color: '#FFF', padding: "6px 12px" }} >
                            <div style={{ fontSize: 18 }}> {languageLable(selectedLanguageData, "Continue")} </div>
                          </Button> 
                      </div> 
        {customFieldDataUSDValue !== "" && customFieldDataUSD !== "" ? (
          <>
            <div className="col-lg-7" style={{ marginTop: -15 }}>
              1 {customFieldDataUSD} = {customFieldDataUSDValue}
            </div>
          </>
        ) : (
          <></>
        )}

        <div className="col-lg-7">
          {isLoyaltyEnable === "true" && this.state.loyaltypoint > 0 ? (
            <div style={{ marginTop: 5 }}>
              <button
                style={{
                  background: "#D3DAD9",
                  color: "#fff",
                  padding: "5px 10px 5px",
                  border: "0px",
                  borderRadius: 8,
                }}
              >
                {languageLable(selectedLanguageData, this.state.loyaltypoint)}{" "}
                {languageLable(selectedLanguageData, "Loyalty Points")}
              </button>
            </div>
          ) : (
            <></>
          )}
        </div>

        {/* </div> */}

        <div className="ps-product__desc" style={{ marginTop: 5 }} />

        <div className="ps-product-attibute">
          {productAttributeValue &&
            productAttributeValue.Attributes &&
            productAttributeValue.Attributes.length > 1 && (
              <div className="attribute-wrapper">
                {this.prepareAttributeOption()}
                <div className="search-container">
                  <button
                    className="ps-btn"
                    onClick={this.props.getSelectedAttributeList}
                  >
                    {languageLable(selectedLanguageData, "Search")}
                  </button>
                </div>
              </div>
            )}

          <Table
            dataSource={attributeData}
            columns={columns}
            //size="middle"
            pagination={
              attributeData && attributeData.length > 10 ? true : false
            }
          />
        </div>
      </div>
    );
  }

  getCartButton = (canOrder, row) => {
      if (this.props.auth && this.props.auth.isLoggedIn && this.props.auth.isVerified && canOrder) {
      const { cartData } = this.props.app;

      let quantity = 0;
      let itemId = null;
      let packingSize = null;
      if (this.state.mainProducts) {
        this.state.mainProducts.forEach((item) => {
          if (item.productId === row.ProductId) {
            quantity = item.quantity;
            itemId = item.productId;
            packingSize = row.PackingSize;
          }
        });
      }
      const { selectedLanguageData } = this.props.app;

      return (
        <React.Fragment>
          <div className="ps-product__shopping ps-product__shopping-table">
            {row.Availability === "Enquiry" ? (
              <figure>
                <div className="form-group--number pointer">
                  <input
                    onClick={() => this.addProductEnquiry(row)}
                    className="form-control pointer"
                    type="text"
                    placeholder={languageLable(
                      selectedLanguageData,
                      "Notify Me"
                    )}
                    readOnly
                  />
                </div>
              </figure>
            ) : (
              <figure>
                {quantity > 0 ? (
                  <React.Fragment>
                    <div className="form-group--number">
                      <button
                        className="up"
                        onClick={() =>
                          this.handleIncreaseItemQty(
                            itemId
                          )
                        }
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                      <button
                        className="down"
                        onClick={() =>
                          this.handleDecreaseItemQty(
                            itemId,
                            quantity
                          )
                        }
                      >
                        <i className="fa fa-minus"></i>
                      </button>
                      <input
                        className="form-control"
                        type="text"
                        placeholder={quantity}
                        disabled
                      />
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {
                      /*row.Availability !== "Unlimited" &&
                    Number(row.Availability) === 0 ? (
                      <div className="form-group--number pointer">
                        ---
                      </div>
                    ) : ( */
                      <div className="form-group--number pointer">
                        <input
                          onClick={() => this.handleAddItemToCart(row)}
                          className="form-control pointer"
                          type="text"
                          placeholder={languageLable(
                            selectedLanguageData,
                            this.state.productAction === PRODUCT_ACTION.EXCHANGE
                              ? "Replace"
                              : this.state.productAction
                          )}
                          readOnly
                        />
                      </div>
                      //)
                    }
                  </React.Fragment>
                )}
              </figure>
            )}
          </div>
        </React.Fragment>
        
      );
    } else {
      return "---";
    }
  };

  addProductEnquiry = (row) => {
    const { selectedLanguageData } = this.props.app;

    api
      .get(`AddProductEnquiry?ListingId=${row.ProductListingId}`)
      .then((response) => {
        if (response.StatusCode === 200 && response.Result) {
          notification.success({
            message: "Success",
            description: languageLable(
              selectedLanguageData,
              "We will notify you once product is available."
            ),
          });
        }
      });
  };
}

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps)(withRouter(SchemeProductDetails));
